import { Spin } from "antd";

/** 懶載入路由區塊時的佔位（已登入後切頁才會出現） */
export default function RouteFallback() {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#f0f2f5",
      }}
    >
      <Spin size="large" />
    </div>
  );
}
